import { EULAprops } from '@usacsmideo/types';

export const EULAheader = (props: EULAprops) => {
  return <h1 className="my-2 text-xs font-bold">{props.text}</h1>;
};
